import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Spinner } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import TimeSlotItemContainer from './TimeSlotsItem/TimeSlotsItemContainer.js';
import { isEqualTimeSlot } from './utils.js';

const TimeSlots = (_param)=>{
    var { className , loading , slots , selected , timeFormatter , onSelectTime  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "loading",
        "slots",
        "selected",
        "timeFormatter",
        "onSelectTime"
    ]);
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('timeslots', className)
    }), loading ? /*#__PURE__*/ React.createElement("div", {
        className: "timeslots__loader"
    }, /*#__PURE__*/ React.createElement(Spinner, {
        "aria-label": getLabel('common.loadingText')
    })) : slots.map((slot)=>/*#__PURE__*/ React.createElement(TimeSlotItemContainer, {
            key: slot.from.toUTCString(),
            selected: isEqualTimeSlot(slot, selected),
            label: timeFormatter(slot.from),
            slot: slot,
            onSelect: onSelectTime
        })
    ));
};

export { TimeSlots as default };
//# sourceMappingURL=TimeSlots.js.map
